<template>
  <div class="relatedWorks">
    <div class="hd">相关作品</div>

    <div class="bd">
      <div v-show="loading">
        <loading></loading>
      </div>
      <div v-show="!loading && works.length!==0">
        <el-carousel :interval="5000"
                     arrow="hover"
                     indicator-position="none"
                     height="260px">
          <el-carousel-item v-for="(item,index) in works"
                            :key="index">

            <a href="javascript:;"
               class="loading_main"
               @click="ondetails(item.topicId)">
              <img :src="item.topicTn.tnUrl"
                   class="image"
                   v-if="item.topicTn">
            </a>

            <div class="title">{{item.title}}</div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div v-if="!loading && works.length==0">
        <div class="null_data"
             style="min-height:230px">
          <img src="@/assets/image/common/null_data.png"
               alt="">
          <p>暂无相关作品...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from '@/components/loading/loading.vue'
import { topicDetail, TopicByTags } from '@/utils/api/findDetail.js'
export default {
  inject: ['reload'],

  name: "relatedWorks",
  data () {
    return {
      loading: true,
      worksdetail: {},
      works: [
      ],

    }
  },
  components: {
    loading
  },
  methods: {
    //获取相关作品
    getSelectTopicByTags (topicId, tags) {
      TopicByTags({ topicId: topicId, tags: tags }).then(res => {
        this.loading = false;
        this.works = res.data.data;

        //console.log(this.works,"获取相关作品")
      })
    },
    async getTopicDetail () {
      let topicDetailid = this.$route.params.id;
      let { data } = await topicDetail({ topicId: topicDetailid });
      this.worksdetail = data.data;
      //console.log(this.worksdetail.topic.topicId,this.worksdetail.topic.tags);
      this.getSelectTopicByTags(this.worksdetail.topic.topicId, this.worksdetail.topic.tags)
    },
    ondetails (topicId) {
      this.$router.push({ path: '/findDetail/' + topicId })
      this.reload()

    }
  },
  mounted () {
    // this.getSelectTopicByTags();
    this.getTopicDetail();
  }
}

</script>

<style lang="scss" scoped="scoped">
div.relatedWorks {
  background: #fff;
  padding: 15px;
  padding-top: 5px;
  display: flow-root;
  div.hd {
    height: 36px;
    line-height: 36px;
    font-size: 18px;
  }
  img.image {
    height: 230px;
    width: 100%;
    object-fit: cover;
  }
  div.title {
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
  }
}
.loading_main {
  min-height: 228px;
  background: #eee;
  float: left;
  width: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/relatedWorks.vue